export default __webpack_public_path__ + "static/media/CaloPitchDeckFinal.2eda8ebd.pdf";